import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { PaymentsModel } from '@/features/project/projects/_models/payment';
import type { z } from 'zod';
import { queryKeyMap } from '../review-sheet/utils/query-keys';

export const useContractorPayments = <T = z.infer<typeof PaymentsModel>>({
  projectId,
  select,
  enabled = true,
}: {
  projectId: string;
  select?: (data: z.infer<typeof PaymentsModel>) => T;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: queryKeyMap.contractorPayments(projectId),
    queryFn: async () => {
      const payments = await axiosGet(
        `/api/projects/${projectId}/contractor-payments/`,
      );
      return PaymentsModel.parse(payments);
    },
    select,
    enabled: enabled && !!projectId,
  });
};
